module.exports = __webpack_public_path__ + "media/images/prevention_form/snus-f05728ee07639f791dcb2bc2bc10acd1.svg";